package nl.volleyplanner.api.backend_jobs

import kotlinx.serialization.Serializable
import nl.volleyplanner.api.planner.HardMediumSoftScore
import nl.volleyplanner.api.types.BigNumber

@Serializable
data class PlannerJobDetails(
    val completionPercentage: Int,
    val lastBestScore: HardMediumSoftScore,
    val totalCalculations: Int,
    val problemEntities: Int,
    val problemVariables: Int,
    val problemValueCount: Int,
    val problemSizeLog10: BigNumber
)